'use client'

import Box from '@mui/material/Box'

import DownloadGuide from '@/components/DownloadGuide'
import GenericHero from '@/components/Hero/GenericHero'
import LearnMoreTiles from '@/components/LearnMoreTiles'
import RequestDemo, { Sector } from '@/components/RequestDemo'
import AutomateScope3Calculations from '@/sections/AutomateScope3Calculations'
import EnableYourUsersProcurement from '@/sections/EnableYourUsersProcurement'
import PlugInAndGoAPI from '@/sections/PlugInAndGoAPI'
import ScopeThree from '@/sections/ScopeThree'
import { HUBSPOT_FORM_IDS } from '@/utills/constants'

export default function Page() {
    return (
        <>
            <GenericHero
                chips={{
                    items: [
                        {
                            src: '/images/heros/chip-procurement-1.png',
                            width: 480,
                            height: 96,
                        },
                        {
                            src: '/images/heros/chip-procurement-2.png',
                            width: 480,
                            height: 96,
                        },
                        {
                            src: '/images/heros/chip-procurement-3.png',
                            width: 480,
                            height: 96,
                        },
                        {
                            src: '/images/heros/chip-procurement-4.png',
                            width: 480,
                            height: 96,
                        },
                    ],
                    gap: 6,
                }}
                backgroundImageMobile={'/images/heros/procurement-mobile.png'}
                title={'Steward sustainable supply chains with end-to-end climate action'}
                description={
                    <>
                        Transform every supply chain into a sustainability powerhouse by integrating
                        the only API that fuses emissions calculations and climate contributions.
                        Propel your business to the forefront of the net zero movement, turning
                        sustainability into a compelling revenue driver.
                    </>
                }
            />
            {/* TODO: Add scrollToSection references */}
            <LearnMoreTiles
                tiles={[
                    {
                        title: 'Best-in-class emission calculations',
                        description:
                            'Unlock granular scope 3 emission calculations that empower your clients to get regulation-ready.',
                        icon: '/icons/icon-accredited.png',
                        scrollToSection: 'animation',
                    },
                    {
                        title: 'Vetted climate projects',
                        description:
                            'Boost customer loyalty by helping your clients reach their sustainability objectives with vetted climate projects.',
                        icon: '/icons/icon-climate-projects.png',
                        scrollToSection: 'vetted-climate-projects',
                    },
                    {
                        title: 'Plug in and go',
                        description:
                            'Secure immediate results via  API integration or spreadsheet upload.',
                        icon: '/icons/icon-plug-in.png',
                        scrollToSection: 'plug-in-and-go',
                    },
                ]}
            />
            <ScopeThree />
            <Box id={'animation'}>
                <AutomateScope3Calculations />
            </Box>
            <Box id={'vetted-climate-projects'}>
                <EnableYourUsersProcurement />
            </Box>
            <DownloadGuide purpleVersion={true} hubspotFormId={HUBSPOT_FORM_IDS.purpleForm} />
            <Box id={'plug-in-and-go'}>
                <PlugInAndGoAPI />
            </Box>
            <RequestDemo sector={Sector.PROCUREMENT} />
        </>
    )
}
